import React from 'react';
export const SuccessCircle = ({ className }: { className?: string }) => (
  <svg
    id="Success-Circle--Streamline-Ultimate"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <g clipPath="url(#clip0_3375_5699)">
      {/* Green Circle */}
      <path
        d="M12.0004 -1.02753e-05C8.78824 0.0501088 5.72456 1.36106 3.47039 3.64999C2.34839 4.77183 1.46311 6.10757 0.867043 7.57798C0.270976 9.0484 -0.0237337 10.6235 0.00039374 12.21C-0.000923858 13.7595 0.303466 15.294 0.896128 16.7257C1.48879 18.1574 2.35808 19.4581 3.4542 20.5533C4.55033 21.6484 5.85175 22.5166 7.28393 23.1081C8.71611 23.6995 10.2509 24.0026 11.8004 24H12.0004C15.2105 23.9709 18.2776 22.6685 20.5278 20.379C22.778 18.0894 24.027 15.0001 24.0004 11.79C24.0034 10.2231 23.6934 8.6714 23.0888 7.22587C22.4841 5.78034 21.597 4.47009 20.4793 3.37196C19.3616 2.27382 18.0359 1.40991 16.5799 0.830881C15.1239 0.251854 13.567 -0.030632 12.0004 -1.02753e-05ZM10.0004 16.54L6.96039 13.5C6.77302 13.3126 6.51866 13.2072 6.25339 13.2072C5.98812 13.2072 5.73376 13.3126 5.54639 13.5C5.35902 13.6874 5.25339 13.9418 5.25339 14.207C5.25339 14.4723 5.35902 14.7266 5.54639 14.914L9.54639 18.914C9.73376 19.1014 9.98812 19.207 10.2534 19.207C10.5187 19.207 10.773 19.1014 10.9604 18.914L18.4604 11.414C18.6478 11.2266 18.7534 10.9723 18.7534 10.707C18.7534 10.4418 18.6478 10.1874 18.4604 10C18.273 9.81263 18.0187 9.707 17.7534 9.707C17.4881 9.707 17.2338 9.81263 17.0464 10L10.0004 16.54Z"
        fill="#00731D"
      />
      {/* White Tick */}
      <path d="M10 16L7.5 13.5L6.5 14.5L10 18L18 10L17 9L10 16Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_3375_5699">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
